import React from 'react';
import { isEqual } from 'lodash';

import {
  HistoryResponseModel,
  MemberHistoryDetailsModel,
} from 'api/adminApiClient';
import PricingAgreementDetailsCard from './PricingAgreementDetailsCard';
import EntityInformationDetailsCard from './EntityInformationDetailsCard';
import GeneralInformationDetailsCard from './GeneralInformationDetailsCard';
import BankingInformationDetailsCard from './BankingInformationDetailsCard';
import BillingInformationDetailsCard from './BillingInformationDetailsCard';
import SupervisorInformationDetailsCard from './SupervisorInformationDetailsCard';
import PrimaryContactInformationDetailsCard from './PrimaryContactInformationDetailsCard';
import TimesheetApproverInformationDetailsCard from './TimesheetApproverInformationDetailsCard';

type Props = {
  userId: string;
  historyItem: HistoryResponseModel;
};

export default function MemberDetailsCard(props: Props) {
  const { historyItem, userId } = props;
  const historyDetails = historyItem.details as MemberHistoryDetailsModel;
  const historyId = historyItem.id || '';

  return (
    <>
      <GeneralInformationDetailsCard
        historyDetails={historyDetails}
        historyId={historyId}
      />

      {!isEqual(
        historyDetails.oldData?.businessInfo?.priceAgreement,
        historyDetails.newData?.businessInfo?.priceAgreement,
      ) && (
        <PricingAgreementDetailsCard
          userId={userId}
          historyDetails={historyDetails}
          historyId={historyId}
        />
      )}

      {!isEqual(
        historyDetails.oldData?.businessInfo?.entityInformation,
        historyDetails.newData?.businessInfo?.entityInformation,
      ) && (
        <EntityInformationDetailsCard
          userId={userId}
          historyDetails={historyDetails}
          historyId={historyId}
        />
      )}

      {!isEqual(
        historyDetails.oldData?.bankingInformation,
        historyDetails.newData?.bankingInformation,
      ) && (
        <BankingInformationDetailsCard
          userId={userId}
          historyDetails={historyDetails}
          historyId={historyId}
        />
      )}

      {!isEqual(
        historyDetails.oldData?.corporateInfo,
        historyDetails.newData?.corporateInfo,
      ) && (
        <>
          {!isEqual(
            historyDetails.oldData?.corporateInfo?.billingInfo,
            historyDetails.newData?.corporateInfo?.billingInfo,
          ) && (
            <BillingInformationDetailsCard
              historyDetails={historyDetails}
              historyId={historyId}
            />
          )}

          {!isEqual(
            historyDetails.oldData?.corporateInfo?.primaryContacts,
            historyDetails.newData?.corporateInfo?.primaryContacts,
          ) && (
            <PrimaryContactInformationDetailsCard
              historyDetails={historyDetails}
              historyId={historyId}
            />
          )}

          {!isEqual(
            historyDetails.oldData?.corporateInfo?.supervisors,
            historyDetails.newData?.corporateInfo?.supervisors,
          ) && (
            <SupervisorInformationDetailsCard
              historyDetails={historyDetails}
              historyId={historyId}
            />
          )}

          {!isEqual(
            historyDetails.oldData?.corporateInfo?.timesheetApprovers,
            historyDetails.newData?.corporateInfo?.timesheetApprovers,
          ) && (
            <TimesheetApproverInformationDetailsCard
              historyDetails={historyDetails}
              historyId={historyId}
            />
          )}
        </>
      )}
    </>
  );
}
